import { render } from "./ReleasesView.vue?vue&type=template&id=d6fce1a4"
import script from "./ReleasesView.vue?vue&type=script&lang=js"
export * from "./ReleasesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__